module.exports = __webpack_public_path__ + "media/images/shared/icon-first-aid-00cbe14e35f006b50d2d441c5bdefeef.png";